import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import AppPage from './App.vue'

const routes = [
  { path: '/', component: AppPage },
  { path: '/index', component: AppPage },
  { path: '/profile', component: AppPage },
  { path: '/task', component: AppPage },
  { path: '/share', component: AppPage },
  { path: '/point', component: AppPage },
  { path: '/feedback', component: AppPage },
  { path: '/article', component: AppPage },
  { path: '/help_comment', component: AppPage }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
